import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../css/result.css";
import PdfOpenLink from "./common/PdfOpenLink";
import thanksSound from "../voice/GATBresult.wav";

function Result() {
  const location = useLocation();
  const navigate = useNavigate();
  const [hasGATB, setHasGATB] = useState(false);

  const { message, pdf_url } = location.state || {};

  useEffect(() => {
    const loginCode = localStorage.getItem("loggedInToken");
    if (!loginCode) return;

    fetch("https://mpzzlvohx7.execute-api.ap-northeast-3.amazonaws.com/prod/api/checkAttended", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ loginCode, type: "GATB" }),
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log("該当タイプの検査結果:", data.exists);
        setHasGATB(data.exists);
      })
      .catch((err) => {
        console.error("GATB判定確認エラー:", err);
      });
  }, []);

  const goToLabel = hasGATB ? "コンサルタントページへ" : "GATB検査へ";

  // 音声再生
  useEffect(() => {
      const audio = new Audio(thanksSound);
      audio.play().catch((error) => {
        console.error("自動再生に失敗しました:", error);
      });
    }, []);

  const handleRestart = () => {
    navigate("/Portal");
  };

  const handleGoNext = () => {
    if (hasGATB) {
      const userName = localStorage.getItem("userName");
      
      // 拠点名を取得（locationNamesを優先、なければcompanyName_findjob）
      const locationNamesStr = localStorage.getItem("locationNames");
      let affiliation = null;
      if (locationNamesStr) {
        try {
          const locationNames = JSON.parse(locationNamesStr);
          if (Array.isArray(locationNames) && locationNames.length > 0) {
            affiliation = locationNames.join('、'); // 複数拠点の場合は「、」で結合
          } else if (typeof locationNames === 'string') {
            affiliation = locationNames;
          }
        } catch (e) {
          // JSON解析に失敗した場合は文字列として扱う
          affiliation = locationNamesStr;
        }
      }
      
      // 拠点名が取得できない場合は企業名をフォールバック
      if (!affiliation) {
        affiliation = localStorage.getItem("companyName_findjob");
      }

      navigate("/consultant", {
        state: {
          userName,
          affiliation,
        },
      });
    } else {
      navigate("/GATBstart");
    }
  };

  return (
    <div className="result-container">
      <h1>診断結果</h1>
      <p style={{ whiteSpace: "pre-wrap" }}>{message}</p>
      {pdf_url ? (
        <PdfOpenLink url={pdf_url} />
      ) : (
        <p style={{ color: "#d32f2f", margin: "10px 0" }}>
          ⚠️ PDFのURLが取得できませんでした。もう一度診断を実行してください。
        </p>
      )}
      <div className="go-to-GATB">
        <button onClick={handleGoNext} className="button">
          {goToLabel}
        </button>
      </div>
      <div className="go-to-portal">
        <button onClick={handleRestart} className="button">
          ポータルページへ
        </button>
      </div>
    </div>
  );
}

export default Result;
